import {_ReactPixi, applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {ObjectBuilder} from '@gongxigames/framework/core/services/ObjectBuilder';
import {IHitArea, Sprite as PixiSprite} from 'pixi.js';
import {InteractionDisplayObject, ImageConfig} from '@gongxigames/framework/core/types';
import {inversifyContainer} from '@gongxigames/framework/core/installer';

type SpriteConfigWithoutType = Omit<ImageConfig, 'type'>;

export type ImageProps = SpriteConfigWithoutType &
    InteractionDisplayObject &
    Omit<_ReactPixi.ISprite, 'hitArea'> &
    {
        hitArea?: IHitArea | null | undefined;
    };

function propsToSpriteConfig(props: ImageProps): ImageConfig {
    return {
        ...props,
        type: 'image'
    };
}

export const Image = PixiComponent<ImageProps, PixiSprite>('Image', {
    create(props: ImageProps): PixiSprite {
        const builder = inversifyContainer.get<ObjectBuilder>(CoreDI.ObjectBuilder);
        const spriteConfig: ImageConfig = propsToSpriteConfig(props);
        const image = builder.buildImage(spriteConfig);

        image.name ??= 'Image';

        return image;
    },
    applyProps(instance: PixiSprite, oldProps: ImageProps, newProps: ImageProps): void {
        const builder = inversifyContainer.get<ObjectBuilder>(CoreDI.ObjectBuilder);
        const props: ImageProps = {
            ...oldProps,
            ...newProps
        };
        const oldP = {...oldProps};
        const newP = {...newProps};
        const spriteConfig: ImageConfig = propsToSpriteConfig(props);

        if (newP.hasOwnProperty('hitArea') && newP.hitArea === undefined) {
            newP.hitArea = null;
        }

        if (oldP.hasOwnProperty('hitArea') && oldP.hitArea === undefined) {
            oldP.hitArea = null;
        }

        applyDefaultProps(instance, oldP, newP);

        builder.updateImage(instance, spriteConfig);
    }
});
